<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <b-col>
                <h1>{{ecmResourceStrings.ttlECMCrawlerReports}}</h1>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <SettingsTable
                :rows="repositories"
                :columns="columns"
                :customOptions="customOptions"
                :actions="actions"
                @sort="sort">
                <template slot="table-header">
                    <h1 class="text-center OT-table-title"></h1>
                </template>
            </SettingsTable>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import SettingsTable from '@/ecm/components/ECMSettingsTable.vue';
import ecmRepositories from '@/ecm/collections/ecmrepositories.js';
import axios from 'axios';
import { showMessage} from '../../utils/commonECM.js';
import { sortOn } from '../../utils/commonECM.js';

export default {
    data() {
        return {
            ecmResourceStrings: require('../../utils/resourceECM.js'),   
            sortDir:'asc',
            confirmationDlg:false,
            configs: [],
            ecmRepositories: new ecmRepositories({paginated: false }),
            loaded: false,
            customOptions:  [],
            columns: [
            {
                name: 'repositoryId',
                label: 'ID',
                sortable: true,
                editable:false,
                width:'10%',
                render(row) {
                    return row.attributes.repositoryId;
                }
            },{
                name: 'repositoryType',
                label: 'Type',
                sortable: true,
                editable:false,
                render(row) {
                    return row.attributes.repositoryType;
                }
            },{
                name: 'description',
                label: 'Description',
                sortable: false,
                editable:false,
                render(row) {
                    return row.attributes.description;
                }
            }],
            actions: [{
                    name: 'reports',
                    label: 'Crawler Reports',
                    callback: (row) => { this.showReports(row); }
            }],
       }
    },

    computed: {
        repositories() {
            return this.configs;
        }
    },

    methods: {
        refresh() {
            this.loaded = true;
        },

        sort(colNumber, dir) {
            var that = this;
            that.sortDir = dir;
            that.configs.sort(sortOn('name', dir));
        },
         
        showReports(rowNumber){
              
           const repositoryId = this.configs[rowNumber].attributes.repositoryId;
           const repositoryType = this.configs[rowNumber].attributes.repositoryType;
           const description = this.configs[rowNumber].attributes.description;
           const repositoryname = this.configs[rowNumber].attributes.repositoryName;
           this.$router.push('/reports/ecmcrawlerreports/reportdetails/' + encodeURIComponent(repositoryId) + '/' + encodeURIComponent(repositoryname) + '/' + encodeURIComponent(repositoryType));
        },

        refresh() {
            var that = this;
            that.configs ==[];
            that.ecmRepositories.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                that.configs =  that.ecmRepositories.resources;
            }
        )
        .catch((err) => {
           
        });
        },
    },
    components: {
        SettingsTable
    },

    mounted() {
        var breadcrumbs = [{
            name: 'reports',
            meta: { label: 'Event Dashboard' }
        },{
            name: 'ecm-reports',
            meta: { label: 'ECM Crawler Reports' }
        }];
       
        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        
        that.ecmRepositories.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
               const ecmrepositorylist =  that.ecmRepositories.resources;
                if(ecmrepositorylist)
                {
                    const len = ecmrepositorylist.length;
                    if(len!=0)
                    {
                        for(var k=0; k<len; k++)
                        {
                            const oneecmrepo = ecmrepositorylist[k];
                            if(oneecmrepo)
                            {
                                const ecmrepositoryid = oneecmrepo.attributes.repositoryId
                                const ecmrepositorytype = oneecmrepo.attributes.repositoryType;
                                if(ecmrepositorytype != 'dbms_generic_v1')
                                {
                                    that.configs.push(oneecmrepo);
                                }
                            }
                        }
                    }
                }
                that.loaded = true;
            }
        )
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        });
    }
}

</script>
